/* eslint-disable react/prop-types */ // TODO: add props
import { Link } from 'react-router-dom';
import cx from 'classnames';
import style from './ReflectionCell.scss';
import { QUESTION_GROKKED } from 'edrolo/domains/exams';

const NO_EXAM_RESPONSE = undefined;

const ReflectionCell = ({
  grokked,
  to,
  onClick,
  className,
  studentAnswer,
  isCorrect,
  isIncorrect,
}) => {
  const El = to ? Link : 'span';
  const linkProps = to ? { to, onClick } : {};
  return (
    <El className={cx(style.wrapper, className)} {...linkProps}>
      <div
        className={cx(style.reflectionCell, {
          [style.correct]: isCorrect,
          [style.incorrect]: isIncorrect,
          [style.positiveGrok]: grokked === QUESTION_GROKKED.YES,
          [style.negativeGrok]: grokked === QUESTION_GROKKED.NO,
          [style.noGrok]:
            grokked === QUESTION_GROKKED.NO_RESPONSE ||
            grokked === NO_EXAM_RESPONSE,
        })}
        {...linkProps}
      >
        {studentAnswer}
      </div>
    </El>
  );
};

export default ReflectionCell;
